import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "margin" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "width-25pct" }
const _hoisted_4 = { class: "width-35pct margin-left-30px" }
const _hoisted_5 = { class: "width-35pct margin-left-30px" }
const _hoisted_6 = { class: "margin factures" }
const _hoisted_7 = { class: "regles-pastilles-group" }
const _hoisted_8 = { class: "container-modale" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_widget_facture = _resolveComponent("widget-facture")!
  const _component_widget_reglement = _resolveComponent("widget-reglement")!
  const _component_widget_document = _resolveComponent("widget-document")!
  const _component_ReglePastille = _resolveComponent("ReglePastille")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_widget_facture)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_widget_reglement)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_widget_document)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createTextVNode(_toDisplayString(_ctx.$t('dashboard.fournisseur.infos.factures.message')) + " ", 1),
        _createElementVNode("span", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.modaleOpen = true)),
          class: "details"
        }, _toDisplayString(_ctx.$t('dashboard.fournisseur.infos.factures.details')), 1),
        _createElementVNode("span", _hoisted_7, [
          _createVNode(_component_ReglePastille, { cle: "dashboardFournisseur.definition" }),
          _createVNode(_component_ReglePastille, { cle: "dashboardFournisseur.coordonneesFacturation" })
        ])
      ])
    ]),
    (_ctx.modaleOpen)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 0,
          onCancel: _cache[1] || (_cache[1] = ($event: any) => (_ctx.modaleOpen = false))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("table", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.societeTriees(), (item) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: item[1]
                  }, [
                    _createElementVNode("td", null, _toDisplayString(item.societe), 1),
                    _createElementVNode("td", null, _toDisplayString(item.mail), 1)
                  ]))
                }), 128))
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}